// This file was generated by org.multipaz.processor.CodeBuilder, do not edit by hand
package org.multipaz.eventlogger

import org.multipaz.cbor.DataItem
import org.multipaz.eventlogger.Event
import org.multipaz.cbor.Cbor
import kotlinx.io.bytestring.ByteString
import org.multipaz.cbor.annotation.CborSerializableGenerated
import org.multipaz.eventlogger.EventVerificationDigitalCredentials
import org.multipaz.eventlogger.EventVerificationIso18013Proximity
import org.multipaz.eventlogger.EventVerificationDefault
import org.multipaz.eventlogger.EventPresentmentDigitalCredentialsMdocApi
import org.multipaz.eventlogger.EventPresentmentDigitalCredentialsOpenID4VP
import org.multipaz.eventlogger.EventPresentmentIso18013AnnexA
import org.multipaz.eventlogger.EventPresentmentIso18013Proximity
import org.multipaz.eventlogger.EventPresentmentUriSchemeOpenID4VP
import org.multipaz.eventlogger.EventProvisioning
import org.multipaz.eventlogger.EventSimple

fun Event.toCbor(): ByteArray {
    return Cbor.encode(toDataItem())
}

@CborSerializableGenerated(schemaId = "QY6vM6CGUiop_dg7dMtNgLeOVMRNO8tJfAOFJfkAmrg")
val Event_cborSchemaId = ByteString(65, -114, -81, 51, -96, -122, 82, 42, 41, -3, -40, 59, 116, -53, 77, -128, -73, -114, 84, -60, 77, 59, -53, 73, 124, 3, -123, 37, -7, 0, -102, -72)

fun Event.Companion.fromCbor(data: ByteArray): Event {
    return Event.fromDataItem(Cbor.decode(data))
}

val Event.Companion.cborSchemaId: ByteString
    get() = Event_cborSchemaId

fun Event.toDataItem(): DataItem {
    return when (this) {
        is EventVerificationDigitalCredentials -> (this as EventVerificationDigitalCredentials).toDataItem()
        is EventVerificationIso18013Proximity -> (this as EventVerificationIso18013Proximity).toDataItem()
        is EventVerificationDefault -> (this as EventVerificationDefault).toDataItem()
        is EventPresentmentDigitalCredentialsMdocApi -> (this as EventPresentmentDigitalCredentialsMdocApi).toDataItem()
        is EventPresentmentDigitalCredentialsOpenID4VP -> (this as EventPresentmentDigitalCredentialsOpenID4VP).toDataItem()
        is EventPresentmentIso18013AnnexA -> (this as EventPresentmentIso18013AnnexA).toDataItem()
        is EventPresentmentIso18013Proximity -> (this as EventPresentmentIso18013Proximity).toDataItem()
        is EventPresentmentUriSchemeOpenID4VP -> (this as EventPresentmentUriSchemeOpenID4VP).toDataItem()
        is EventProvisioning -> (this as EventProvisioning).toDataItem()
        is EventSimple -> (this as EventSimple).toDataItem()
    }
}

fun Event.Companion.fromDataItem(dataItem: DataItem): Event {
    val type = dataItem["type"].asTstr
    return when (type) {
        "VerificationDigitalCredentials" -> EventVerificationDigitalCredentials_fromDataItem(dataItem)
        "VerificationIso18013Proximity" -> EventVerificationIso18013Proximity_fromDataItem(dataItem)
        "Verification" -> EventVerificationDefault_fromDataItem(dataItem)
        "PresentmentDigitalCredentialsMdocApi" -> EventPresentmentDigitalCredentialsMdocApi_fromDataItem(dataItem)
        "PresentmentDigitalCredentialsOpenID4VP" -> EventPresentmentDigitalCredentialsOpenID4VP_fromDataItem(dataItem)
        "PresentmentIso18013AnnexA" -> EventPresentmentIso18013AnnexA_fromDataItem(dataItem)
        "PresentmentIso18013Proximity" -> EventPresentmentIso18013Proximity_fromDataItem(dataItem)
        "PresentmentUriSchemeOpenID4VP" -> EventPresentmentUriSchemeOpenID4VP_fromDataItem(dataItem)
        "Provisioning" -> EventProvisioning_fromDataItem(dataItem)
        "Simple" -> EventSimple_fromDataItem(dataItem)
        else -> throw IllegalArgumentException("wrong type: $type")
    }
}
